export default __webpack_public_path__ + "media/calculatorpreview.fca6c3bf9b5236f65dc62c04b95d1a9e.png";